export enum MutationTypes {
  SET_LOCATION = 'setLocation',
  GET_LOCATION = 'getLocation',
  SET_DATA = 'setData',
  GET_DATA = 'getData',
  GET_PAGE = 'getPage',
  SET_PAGE = 'setPage',
}
